/** Helpers the org prompt, gate, banner and update notice share. */

import type { TFunction } from "i18next";

import { useOrgs } from "@/api/hooks";
import { formatCalendarDay } from "@/i18n/format";

/** The org's display name, or its slug while the org list loads. */
export function useOrgName(slug: string): string {
  const orgs = useOrgs();
  const list = Array.isArray(orgs.data) ? orgs.data : [];
  return list.find((o) => o.slug === slug)?.name ?? slug;
}

/** A ``YYYY-MM-DD`` legal date (Sweden) in the UI language. */
export function legalDay(day: string | null | undefined): string {
  return day ? formatCalendarDay(day) : "";
}

/** A short, translated line per change-item kind (``summary_key``). */
export function changeSummary(t: TFunction, kind: string): string {
  switch (kind) {
    case "template_revision":
      return t("legal.update.summary.template_revision");
    case "new_document":
      return t("legal.update.summary.new_document");
    case "provider_announced":
      return t("legal.update.summary.provider_announced");
    case "provider_activated":
      return t("legal.update.summary.provider_activated");
    case "provider_removed":
      return t("legal.update.summary.provider_removed");
    case "material_announced":
      return t("legal.update.summary.material_announced");
    case "material_change":
      return t("legal.update.summary.material_change");
    case "wording_change":
      return t("legal.update.summary.wording_change");
    case "addon_available":
      return t("legal.update.summary.addon_available");
    case "addon_replaced":
      return t("legal.update.summary.addon_replaced");
    default:
      return t("legal.update.summary.unexplained");
  }
}

